import { gql } from "@apollo/client";

export const GetProjects = gql`
  query GetProjects(
    $token: String!
    $customerID: ID!
    $empID: ID!
    $after: Cursor
    $first: Int
    $orderBy: AtsAcLdgrProjectsOrder
    $name: String
  ) {
    GetProjects(
      token: $token
      customerID: $customerID
      empID: $empID
      after: $after
      first: $first
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          contractValue
          projectScope
          workOrderNum
          contractSignedWith
          loa
          agreementDate
          startDate
          endDate
          insuranceStartDate
          insuranceEndDate
          goLiveDate
          amcStartDate
          amcScope
          amcInsuranceStartDate
          amcInsuranceEndDate
          dlpStartDate
          dlpEndDate
          bgValue
          bgStartDate
          bgEndDate
          slaBillingCycle
          agreementFile
          endAgreementFile
          customerID
          ldgrID
          supplierName {
            id
            desc
            supplier_details {
              state
              email
              phone
              gstNo
              proficiency
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetProjectByNodeIdForIntData = gql`
  query GetProjectByNodeIdForIntData($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      ... on AtsAcLdgrProjects {
        name
        supplierName {
          desc
        }
      }
    }
  }
`;

export const GetProjectByNodeId = gql`
  query GetProjectByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsAcLdgrProjects {
        id
        name
        contractValue
        projectScope
        workOrderNum
        contractSignedWith
        loa
        agreementDate
        startDate
        endDate
        insuranceStartDate
        insuranceEndDate
        goLiveDate
        amcStartDate
        amcScope
        amcInsuranceStartDate
        amcInsuranceEndDate
        dlpStartDate
        dlpEndDate
        bgValue
        bgStartDate
        bgEndDate
        slaBillingCycle
        agreementFile
        endAgreementFile
        customerID
        ldgrID
        supplierName {
          id
          desc
          supplier_details {
            state
            email
            phone
            gstNo
            proficiency
          }
        }
      }
    }
  }
`;

export const GetProjectNameInNodeId = gql`
  query GetProjectNameInNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsAcLdgrProjects {
        id
        name
        startDate
        endDate
        name
        supplierName {
          id
          desc
        }
      }
    }
  }
`;

export const GetMomNameByNodeId = gql`
  query GetMomNameByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsMomMaster {
        id
        meetingDate
        meetingNo
      }
    }
  }
`;

export const GetProjectsTableHeaderCount = gql`
  query GetProjectsTableHeaderCount(
    $token: String!
    $customerID: ID!
    $empID: ID!
    $toAddHeaders: Boolean!
  ) {
    GetProjectsTableHeaderCount(
      token: $token
      customerID: $customerID
      empID: $empID
      toAddHeaders: $toAddHeaders
    ) {
      projectDetails {
        id
        name
        supplierName {
          desc
        }
      }
      headerCount
    }
  }
`;

export const GetProjectDetailsById = gql`
  query GetProjectDetailsById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsAcLdgrProjects {
        id
        name
        startDate
        endDate
        supplierName {
          id
          desc
        }
      }
    }
  }
`;

export const GetProjectsHeaders = gql`
  query GetProjectsHeaders($token: String!, $customerID: ID!, $projectID: ID!) {
    GetProjectsHeaders(
      token: $token
      customerID: $customerID
      projectID: $projectID
    ) {
      id
      dataType
      header
      idx
      initData
    }
  }
`;

export const GetAtsProjectHeadersById = gql`
  query GetAtsProjectHeadersById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsProjectHeaders {
        id
        header
        initData
        dataType
        status
        projectID
        ldgrID
        customerID
      }
    }
  }
`;

export const GetProjectDailyReports = gql`
  query GetProjectDailyReports(
    $token: String!
    $customerID: ID!
    $projectID: ID!
    $startDate: Time
    $endDate: Time
    $after: Cursor
    $first: Int
    $orderBy: AtsProjectDailyReportsOrder
  ) {
    GetProjectDailyReports(
      token: $token
      customerID: $customerID
      projectID: $projectID
      startDate: $startDate
      endDate: $endDate
      after: $after
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          reportDate
          count
          param1
          param2
          param3
          param4
          param5
          param6
          param7
          param8
          param9
          param10
          param11
          param12
          param13
          param14
          param15
          param16
          param17
          param18
          param19
          param20
          param21
          param22
          param23
          param24
          param25
          pmuRemarks
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetProjectDailyReportsById = gql`
  query GetProjectDailyReportsById($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsProjectDailyReports {
        id
        reportDate
        count
        param1
        param2
        param3
        param4
        param5
        param6
        param7
        param8
        param9
        param10
        param11
        param12
        param13
        param14
        param15
        param16
        param17
        param18
        param19
        param20
        param21
        param22
        param23
        param24
        param25
        pmuRemarks
      }
    }
  }
`;

export const CheckProjectAnyInitHeader = gql`
  query CheckProjectAnyInitHeader(
    $token: String!
    $customerID: ID!
    $projectID: ID!
  ) {
    CheckProjectAnyInitHeader(
      token: $token
      customerID: $customerID
      projectID: $projectID
    )
  }
`;

export const CheckProjectDailyReportStarted = gql`
  query CheckProjectDailyReportStarted(
    $token: String!
    $customerID: ID!
    $projectID: ID!
  ) {
    CheckProjectDailyReportStarted(
      token: $token
      customerID: $customerID
      projectID: $projectID
    )
  }
`;

export const AtsProjectDailyReportsById = gql`
  query AtsProjectDailyReportsById($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsProjectDailyReports {
        id
        pmuRemarks
        reportDate
      }
    }
  }
`;
